module.exports = __webpack_public_path__ + "static/media/new-serena-win.3b157b8e.png";